import footer from './modules/footer.json';
import tournament from './modules/tournament.json';
import teams from './modules/teams.json';
import errors from './modules/errors.json';
import team from './modules/team.json';
import common from './modules/common.json';


export const ru = {
  translation: {
    footer,
    tournament,
    teams,
    errors,
    team,
    common,

    // Forgive me Gods
    "Incorrect password": "Неверный пароль",
  }
};
